import { overrideFeatureFlag } from 'app/state/featureFlags'
import { FeatureFlag } from 'app/types'

declare global {
  interface Window {
    __cartoInternalModifier(action: string, ...args: unknown[]): void
  }
}

function cartoInternalModifier(action: string, ...args: unknown[]) {
  switch (action) {
    case 'overrideFeatureFlag':
      return overrideFeatureFlag(...(args as [FeatureFlag, boolean]))
    default:
      return
  }
}

window.__cartoInternalModifier = cartoInternalModifier
